import {
  FETCH_ALL_DELIVERY_NOTES,
  FETCH_ALL_DELIVERY_NOTES_SUCCESS,
  FETCH_ALL_DELIVERY_NOTES_FAILURE,
  FETCH_DELIVERY_NOTE_DETAILS,
  FETCH_DELIVERY_NOTE_DETAILS_SUCCESS,
  FETCH_DELIVERY_NOTE_DETAILS_FAILURE,
  CREATE_DELIVERY_NOTE,
  CREATE_DELIVERY_NOTE_SUCCESS,
  CREATE_DELIVERY_NOTE_FAILURE,
  UPDATE_DELIVERY_NOTE,
  UPDATE_DELIVERY_NOTE_SUCCESS,
  UPDATE_DELIVERY_NOTE_FAILURE,
  DELETE_DELIVERY_NOTE,
  DELETE_DELIVERY_NOTE_SUCCESS,
  DELETE_DELIVERY_NOTE_FAILURE,
  SET_DELIVERY_NOTE_IS_EDIT,
} from "./constants";

const initialState = {
  allDeliveryNotes: [],
  deliveryNoteDetails: null,
  fetchDeliveryNotesLoading: false,
  fetchDeliveryNoteDetailsLoading: false,
  createDeliveryNoteLoading: false,
  updateDeliveryNoteLoading: false,
  deleteDeliveryNoteLoading: false,
  totalRecords: 0,
  isEdit: false,
  error: null,
};

const deliveryNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all delivery notes
    case FETCH_ALL_DELIVERY_NOTES:
      return {
        ...state,
        fetchDeliveryNotesLoading: true,
      };
    case FETCH_ALL_DELIVERY_NOTES_SUCCESS:
      return {
        ...state,
        allDeliveryNotes: action.payload.data,
        totalRecords: action.payload.total,
        fetchDeliveryNotesLoading: false,
      };
    case FETCH_ALL_DELIVERY_NOTES_FAILURE:
      return {
        ...state,
        error: action.payload,
        fetchDeliveryNotesLoading: false,
      };

    // Fetch delivery note details
    case FETCH_DELIVERY_NOTE_DETAILS:
      return {
        ...state,
        fetchDeliveryNoteDetailsLoading: true,
      };
    case FETCH_DELIVERY_NOTE_DETAILS_SUCCESS:
      return {
        ...state,
        deliveryNoteDetails: action.payload,
        fetchDeliveryNoteDetailsLoading: false,
      };
    case FETCH_DELIVERY_NOTE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
        fetchDeliveryNoteDetailsLoading: false,
      };

    // Create delivery note
    case CREATE_DELIVERY_NOTE:
      return {
        ...state,
        createDeliveryNoteLoading: true,
      };
    case CREATE_DELIVERY_NOTE_SUCCESS:
      return {
        ...state,
        createDeliveryNoteLoading: false,
      };
    case CREATE_DELIVERY_NOTE_FAILURE:
      return {
        ...state,
        error: action.payload,
        createDeliveryNoteLoading: false,
      };

    // Update delivery note
    case UPDATE_DELIVERY_NOTE:
      return {
        ...state,
        updateDeliveryNoteLoading: true,
      };
    case UPDATE_DELIVERY_NOTE_SUCCESS:
      return {
        ...state,
        updateDeliveryNoteLoading: false,
      };
    case UPDATE_DELIVERY_NOTE_FAILURE:
      return {
        ...state,
        error: action.payload,
        updateDeliveryNoteLoading: false,
      };

    // Delete delivery note
    case DELETE_DELIVERY_NOTE:
      return {
        ...state,
        deleteDeliveryNoteLoading: true,
      };
    case DELETE_DELIVERY_NOTE_SUCCESS:
      return {
        ...state,
        allDeliveryNotes: state.allDeliveryNotes.filter(
          (note) => note.id !== action.payload.id
        ),
        deleteDeliveryNoteLoading: false,
      };
    case DELETE_DELIVERY_NOTE_FAILURE:
      return {
        ...state,
        error: action.payload,
        deleteDeliveryNoteLoading: false,
      };

    // Set delivery note is edit
    case SET_DELIVERY_NOTE_IS_EDIT:
      return {
        ...state,
        isEdit: action.payload,
      };

    default:
      return state;
  }
};

export default deliveryNoteReducer;
